/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ApiLimitsDirective from './api-limits.directive';

export default angular.module('tektelic.apiLimits', [])
    .directive('tkApiLimits', ApiLimitsDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/api-limits/index.js